import useFranchiseHook from "@/shared/hooks/useFranchiseHook";
import useKioskSettingsQuery from "@/shared/queries/kioskSettings/useKioskSettingsQuery";
import { useMemo } from "react";
import Stock from "../../../App/Assets/Images/stock.jpg";
import {
  DEFAULT_IMAGE_ID,
  imageType,
} from "../Settings/WebsiteSettings/Settings";
import useGenerateImageUrl from "@/shared/hooks/useGenerateImageUrl";

const useKioskSliderImages = () => {
  const [franchiseId] = useFranchiseHook();
  const kioskSettingsQuery = useKioskSettingsQuery();
  const generateImageUrl = useGenerateImageUrl();

  return useMemo(() => {
    const sliders = kioskSettingsQuery.data?.home_sliders || [];
    const mapped = sliders
      .filter((slider) => slider && slider !== DEFAULT_IMAGE_ID)
      .map((slider) => generateImageUrl(slider, imageType.SLIDER, franchiseId));
    return mapped.length ? mapped : [Stock];
  }, [kioskSettingsQuery.data?.home_sliders, franchiseId]);
};

export default useKioskSliderImages;
